import type { VoidFunctionComponent } from 'react';
import ContentLoader from 'react-content-loader';

const TeamSelectionMenuLoading: VoidFunctionComponent = () => (
  <ContentLoader
    speed={2}
    width="100%"
    height={110}
    viewBox="0 0 300 110"
  >
    {/* mimic some rows of teams */}
    <rect x="0" y="0" rx="4" ry="4" width="100%" height="34" />
    <rect x="0" y="38" rx="4" ry="4" width="100%" height="34" />
    <rect x="0" y="76" rx="4" ry="4" width="100%" height="34" />
  </ContentLoader>
);

export default TeamSelectionMenuLoading;
